
function fireShopfloAnalyticsEvent(platform, merchantID) {
  let payload = [{
    eventName: "checkout_clicked",
    sessionId: window.Shopflo.getSessionId(),
    timestamp: Date.now(),
    merchantId: merchantID,
    eventPayload: {
      uiData: { source: platform },
      clientData: {
        clientIp: window.Shopflo?.clientMeta?.client_ip,
        userAgent: window.Shopflo?.clientMeta?.user_agent,
      },
    },
    eventType: "click",
    channel: "web",
  }];

  // if (navigator?.sendBeacon && Blob) {
  //   let blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
  //   navigator.sendBeacon("https://alpenliebe20250305050635.shopflo.com/api/v1/spark", blob);
  // }
  fetch("https://alpenliebe20250305050635.shopflo.com/api/v1/spark", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
    keepalive: true, // keeps it similar to sendBeacon behavior
  })
    .then(res => {
      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      return res.json();
    })
    .then(data => {
      console.log("Shopflo event fired:", data);
    })
    .catch(err => {
      console.error("Error firing Shopflo event:", err);
    });

}

function getCookie(name) {
  let match = document.cookie.match(RegExp("(?:^|;\\s*)" + name + "=([^;]*)"));
  return match ? match[1] : null;
}

function isFloEnabled() {
  return Math.random() < 0.2 ? "shopflo" : "magic";
}

function displaySelectedButtonCP() {
  if (getCookie("flo_checkout_enabled") === "shopflo") {
     document
      .querySelector("#magic-wrapper")
      .style.setProperty("display", "none", "important");
    document
      .querySelectorAll("#shopflo-wrapper").forEach(function (buttonElement) {buttonElement.style.setProperty("display", "block", "important")})
  } else {
     document
      .querySelector("#shopflo-wrapper")
      .style.setProperty("display", "none", "important");
    document
      .querySelectorAll("#magic-wrapper").forEach(function (buttonElement) {buttonElement.style.setProperty("display", "block", "important")})
  }
  console.log("Yash");
}


function displaySelectedButtonBuyNow() {
  console.log("Buy Now");
  if (getCookie("flo_checkout_enabled") === "shopflo") {
    document
      .querySelector("#shopflo-wrapper-buy")
      .style.setProperty("display", "block", "important");
    document
      .querySelector("#magic-wrapper-buy")
      .style.setProperty("display", "none", "important");
  } else {
    document
      .querySelector("#magic-wrapper-buy")
      .style.setProperty("display", "block", "important");
    document
      .querySelector("#shopflo-wrapper-buy")
      .style.setProperty("display", "none", "important");
  }
}


if (!getCookie("flo_checkout_enabled")) {
  let today = new Date();
  let expire = new Date(today.getTime() + 1000 * 60 * 60 * 24 * 3); // 3 days
  document.cookie =
    "flo_checkout_enabled=" +
    isFloEnabled() +
    ";path=/;expires=" +
    expire.toUTCString();
}

document.addEventListener("DOMContentLoaded", function () {
  displaySelectedButtonCP();
  displaySelectedButtonBuyNow();
});




